namespace Roodik.Game
{
	import ResourceLoader = Roodik.Core.ResourceLoader;
	import ResourceProvider = Roodik.Core.ResourceProvider;
	import IGameResources = Roodik.Core.IGameResources;
	import IResourceDictionary = PIXI.loaders.IResourceDictionary;
	import DragonBonesResourceLoader = Roodik.Core.DragonBonesResourceLoader;

	export interface ILanguage
	{
		id:string;
		code:string;
	}

	export class GameResources implements IGameResources
	{
		private _resources: IResourceDictionary;
		private _locale:string = this.getLocale(new Array<ILanguage>(
		{id:"en-US",code:"en-US"},
		      {id:"ru-RU",code:"ru-RU"},
		      {id:"ru",code:"ru-RU"},
			{id:"cs-CZ",code:"cs-CZ"},
			{id:"cs",code:"cs-CZ"},
			{id:"de-DE",code:"de-DE"}));

		private getLocale(availableLocale:Array<ILanguage>):string
		{
			let userLanguage = "en-US";
			availableLocale.forEach((language)=>{
				if(language.id == window.navigator.language)
				{
					userLanguage = language.code;
				}
			});
			return userLanguage;
		}

		public loadMixedLazy(progressChanged: (progress) => void, loaded: () => void)
		{
			this.loadDbLazy("game", "resources/images/",
			progressChanged, ()=>{
				
				let provider = new ResourceProvider();
				provider.add("LocalizationData","resources/localization/"+this._locale+".json");
				provider.add("LevelsData","resources/data/puzzlescfg.json");
				this.loadLazy(provider,()=>{},()=>{
					loaded();
				});
			});
		}

		public loadDbLazy(name: string, url: string, progressChanged: (progress) => void, loaded: () => void)
		{
			let loader = new DragonBonesResourceLoader();
			let provider: ResourceProvider = new ResourceProvider();
			provider.add(name + "_ske.json", url + name + "_ske.json");
			provider.add(name + "_tex.json", url + name + "_tex.json");
			provider.add(name + "_tex.png", url + name + "_tex.png");

			loader.load(provider, progressChanged, (resources) =>
			{
				const factory = dragonBones.PixiFactory.factory;
				factory.parseDragonBonesData(resources[name + "_ske.json"].data);
				factory.parseTextureAtlasData(resources[name + "_tex.json"].data, resources[name + "_tex.png"].texture);
				this.addToResources(resources);
				loaded();
			});
		}

		public loadLazy(provider: ResourceProvider, progressChanged?: (progress) => void, loaded?: () => void)
		{
			let loader: ResourceLoader = new ResourceLoader();
			loader.load(provider, progressChanged, (resources) =>
			{
				this.addToResources(resources);
				if (loaded != null)
				{
					loaded();
				}
			});
		}

		private addToResources(resources)
		{
			if (this._resources == null)
			{
				this._resources = resources;
			}
			else
			{
				for (let key in resources)
				{
					if (this._resources[key] != null)
					{
						// throw new Error("Resource with key <" + key + "> already exist");
					}
					else
					{
						this._resources[key] = resources[key];
					}
				}
			}
		}

		public getResourceByName(name: string)
		{
			let res = this._resources[name];
			return res == undefined ? null : res;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/GameResources.ts